import { useRegisterSW } from 'virtual:pwa-register/react';
import { toaster } from '@/core/ui';

export const VersionManager = () => {
  const { updateServiceWorker } = useRegisterSW({
    onRegisterError(error) {
      console.error(error);
    },
    onNeedRefresh() {
      toaster.updateToast(() => {
        updateServiceWorker(true);
      });
    },
  });

  return null;
};
